import React from 'react';

import { MixPanelTrackedLink } from './MixPaneTrackedLink';
import { useSelector } from 'react-redux';
import { currencyNeedsSpace } from '../helpers';

export function DefaultAmountCard({ currency, handleDefaultAmountSelect, donationAmount }) {
	const selectedCurrency = useSelector((state) => state.donationCheckout.selectedCountry.currency.symbol);
	const isOptionSelected = currency.default_value == donationAmount;
	return (
		<MixPanelTrackedLink
			key={currency.id}
			id="defaultAmount"
			name="donationAmount"
			className="default-amount-card"
			sx={{
				color: 'black',
				border: `1px solid ${isOptionSelected ? '#00884c' : '#d8d8d8'} !important`,
				fontWeight: isOptionSelected ? '600' : '400',
				transform: isOptionSelected ? 'scale(1.02)' : 'scale(1)',
				transition: 'transform 0.1s ease-in-out, font-weight 0.1s ease-in-out',
				boxShadow: isOptionSelected ? '0px 2px 6px rgba(0, 0, 0, 0.08)' : 'none',
			}}
			value={currency.default_value.toLocaleString()}
			onClick={handleDefaultAmountSelect}
			type="button"
			context="Default amount option on checkout page"
			label={`${currency.default_value.toLocaleString()}`}
			fullWidth
			disableRipple
		>
			{selectedCurrency}
			{currencyNeedsSpace(selectedCurrency) ? ' ' : ''}
			{currency.default_value.toLocaleString()}
		</MixPanelTrackedLink>
	);
}
